import React from "react";

function MyStrategies() {
  const strategies = [
    {
      id: 1,
      name: "Nifty-ATM +2 Straddle",
      capital: "₹17.50L",
      pnl: "₹3.97K",
      status: "Paused",
      multiplier: "1x",
      execution: "Live",
    },
    {
      id: 2,
      name: "VWAP + 9 EMA Option Buying",
      capital: "₹50.00K",
      pnl: "₹-367.25",
      status: "Active",
      multiplier: "1x",
      execution: "Forward",
    },
    {
      id: 3,
      name: "Nifty Momentum Buy Options",
      capital: "₹30.00K",
      pnl: "₹0.00",
      status: "Active",
      multiplier: "1x",
      execution: "Live",
    },
    {
      id: 4,
      name: "Buy OTM Call",
      capital: "₹35.00K",
      pnl: "₹-263.25",
      status: "Live",
      multiplier: "1x",
      execution: "Forward",
    },
  ];

  return (
    <main className="my_strategies ">
      <div className="container pt_150 pb_150 mt-5">
        <section className="dashboard_header">
          <h2>Track & Manage Your Algo</h2>
          <p>
            Get a complete overview of your strategies, performance, positions,
            and order activity.
          </p>
          {/* <div className="header_actions">
            <button className="btn">FORWARD</button>
            <button className="btn">LIVE</button>
            <button className="btn">Refresh</button>
            <button className="btn btn_exit">Exit All</button>
          </div> */}
        </section>

        {/* <section className="tabs_section">
          <ul className="tabs">
            <li className="active">Deployed Algos</li>
            <li>Positions</li>
            <li>OrderBook</li>
            <li>Performance Report</li>
          </ul>
        </section> */}

        <section className="table_section">
          <table className="strategies_table">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Strategy Name</th>
                <th>Deployed Capital</th>
                <th>Today's P&L</th>
                <th>Status</th>
                {/* <th>Multiplier</th> */}
                <th>Execution Type</th>
                <th>Actions</th>
                {/* <th>Trade Details</th> */}
              </tr>
            </thead>
            <tbody>
              {strategies.map((s) => (
                <tr key={s.id}>
                  <td>{s.id}</td>
                  <td>{s.name}</td>
                  <td>{s.capital}</td>
                  <td
                    className={s.pnl.startsWith("₹-") ? "negative" : "positive"}
                  >
                    {s.pnl}
                  </td>
                  <td className={`status ${s.status.toLowerCase()}`}>
                    {s.status}
                  </td>
                  {/* <td>{s.multiplier}</td> */}
                  <td>{s.execution}</td>
                  <td>
                    <button className="btn_small">...</button>
                  </td>
                  {/* <td>
                    <button className="btn_small">📋</button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>
    </main>
  );
}

export default MyStrategies;
